var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme-toggle",attrs:{"title":_vm.theme === 'dark' ? '切换到白天模式' : '切换到夜间模式'},on:{"click":_vm.toggle}},[_c('i',{class:_vm.theme === 'dark' ? 'el-icon-moon' : 'el-icon-sunny'})])}
var staticRenderFns = []

export { render, staticRenderFns }